@if (breadcrumbs().length) {
  <nav [attr.aria-label]="'common.breadcrumbs' | translate" class="app-company-breadcrumbs">
    <ol>
      @for (breadcrumb of breadcrumbs(); track breadcrumb.path) {
        <li>
          @if (breadcrumb.isCurrent) {
            <span aria-current="page">{{ breadcrumb.label }}</span>
          } @else if ($first) {
            <a [attr.aria-label]="breadcrumb.label" [routerLink]="breadcrumb.path">
              <mat-icon aria-hidden="true">home</mat-icon>
            </a>
          } @else {
            <a [routerLink]="breadcrumb.path">{{ breadcrumb.label }}</a>
          }
        </li>
      }
    </ol>
  </nav>
}
